/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-loop-func */
/* eslint-disable no-restricted-syntax */
import React, {
  useState, useMemo, useEffect, useRef,
} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  Grid, useMediaQuery, useTheme,
} from '@material-ui/core';
import {
  Timelapse, DoneAll, Add, Remove, Save,
} from '@material-ui/icons';

import {
  useMaestroDataSource, useTranslation,
} from '@michelin/central-provider';
import {
  Panel, Fab, Tabs, Tab, AppBar, Container, GlobalActions, useDialogs, Switch, PreventTransitionPrompt, AccountAvatar, TextFieldUOM, Select,
} from '@michelin/acid-components';
import { getOptions } from '@michelin/select-options-provider';
import DataGrid, {
  SearchPanel, Column, Selection,
} from 'devextreme-react/data-grid';
// import { Template } from 'devextreme-react/core/template';
import { cloneDeep } from 'lodash';
import { get } from 'react-hook-form';
import { HoursOfOperation, ProviderLocation } from 'Types';
import {
  getTimeString, FOOTERED_CONTENT_AREA_HEIGHT, scrollToDisplayElementById, getKeys,
} from 'Utils';
import { getDates } from 'components/HoursOfOperation/Types';
import { useMutation } from 'react-query';
import { massUpdateLocationServices } from 'hooks/useUpdateLocationService';
import { massUpdateLocationHOO } from 'hooks/useUpdateLocationHOO';
import { massUpdatelocationsList, massUpdateLocationOFB, massValidateNafaService } from 'hooks/useMassSTUpdate';
import usePermissionsSPP from 'hooks/usePermissionsSPP';
import useUtils from 'hooks/useUtils';
import { UOM } from '@michelin/acid-components/build/components/TextFieldUOM/TextFieldUOM';
import { serviceFieldLabels } from 'components/Services/ServicesFields';
import { PageTitle } from 'Utils/CanvasPageTitle';
import POSInfoIcon from 'components/POS/POSInfoIcon';
import { checkCRetailMaxServiceRadius } from 'components/Location/LocationPanel';
import ServicesPanel from '../Services/ServicesPanel';
import { HoursOfOperationEdit } from '../HoursOfOperation/Edit';
import { MustEnableField } from './MustEnableField';

function hasTrueValue(data: any) {
  if (!data) return false;
  if (data === true) return true;
  if (typeof data !== 'object') return false;
  for (const field in data) {
    if (hasTrueValue(data[field])) return true;
  }
  return false;
}

const hasSelectedServicesFn = (services: any) => {
  if (services.all_brands) return true;
  if ((services.brands || []).length > 0) return true;

  for (const srv in services) {
    if (!services) continue;
    if (!services[srv]) continue;
    if (srv === 'mobile_service_radius') continue;
    if (hasTrueValue(services[srv])) return true;
  }
  return false;
};

function MassSTUpdate() {
  const { t } = useTranslation();
  const { btNumber, tab } = useParams<{ btNumber: string, tab: string }>();
  const {
    errorDialog, messageDialog, confirmDialog, loadingDialog,
  } = useDialogs();
  const history = useHistory();
  const permissions = usePermissionsSPP();
  const { subTitle, convertFromUOM } = useUtils();
  const [saving, setSaving] = useState(false);
  const theme = useTheme();
  const tabletView = useMediaQuery(theme.breakpoints.down(960));
  const [hours_of_operation, setHours_of_operation] = useState({});
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [savesCounter, setSavesCounter] = useState(0);
  const [hasSelectedServices, setHasSelectedServices] = useState(false);
  const [hasHOO, setHasHOO] = useState(false);
  const [openForBusiness, setOpenForBusiness] = useState<boolean | undefined>(undefined);
  const [posType, setPosType] = useState<string | undefined>(undefined);
  const [mobileOnly, setMobileOnly] = useState<boolean | undefined>(undefined);
  const [serviceRadius, setServiceRadius] = useState<string | undefined>(undefined);
  const [stServices, setStServices] = useState<any>({ services: {} });
  const [selectedTab, setSelectedTab] = useState(tab);

  type TabName = 'adm' | 'ofb' | 'services' | 'hoo';
  const uom = permissions.location?.customer_country.toLocaleLowerCase() === 'us' ? UOM.miles : UOM.km;

  const dataGrid = useRef<DataGrid>(null);
  if (tab === 'ofb' && !permissions.allowsAction('update_open_for_business.update')) history.push('services');

  useEffect(() => {
    setHasHOO(JSON.stringify(hours_of_operation) !== '{}');
  }, [hours_of_operation]);

  useEffect(() => {
    setSelectedTab(tab);
    setOpenForBusiness(undefined);
    setMobileOnly(undefined);
    setServiceRadius(undefined);
    setPosType(undefined);
    setHours_of_operation({});
    setStServices({ services: {} });
    setHasSelectedServices(false);
  }, [tab, savesCounter]);

  const locationInformationChanges = openForBusiness !== undefined || mobileOnly !== undefined || serviceRadius !== undefined || posType !== undefined;

  const mutateLocationServices = useMutation(massUpdateLocationServices);
  const mutateLocationHOO = useMutation(massUpdateLocationHOO);
  const mutateLocationOFB = useMutation(massUpdateLocationOFB);

  const stList = useMaestroDataSource({
    API: massUpdatelocationsList(btNumber),
    reqOptions: { filters: { reduced: 'true', type: 'lt,aad' }, per_page: 5000 },
    cacheKey: 'mass-st-update',
  });

  const countryCode = permissions.location?.customer_country.toLocaleLowerCase() || 'us';

  if (!permissions.allowsAction('mass_st_update.update')) {
    history.push(`/${btNumber}`);
  }

  const getDataToSave = (data: any, type: string) => {
    const cloneData = cloneDeep(data);
    getKeys(cloneData).forEach((key) => {
      if (typeof (cloneData[key]) === 'object') {
        cloneData[key] = getDataToSave(cloneData[key], type);
        if (Object.keys(cloneData[key]).length === 0) delete cloneData[key];
      } else {
        if (type === 'all' && cloneData[key] === undefined) {
          if (key === 'mobile_service_radius') delete cloneData[key];
          else cloneData[key] = false as any;
        }
        if (type === 'all') return;
        if (cloneData[key] === undefined || Number.isNaN(cloneData[key])) delete cloneData[key];
        if (cloneData[key] === false) delete cloneData[key];
        if (cloneData[key] === true && type === 'remove') cloneData[key] = false as any;
      }
    });
    return cloneData;
  };

  const missingNationalAccountOptions = (services: any): boolean => {
    const missingOptions = !!services?.programs?.processes_national_accounts && !services?.programs?.michelin_national_account && !services?.programs?.autointegrate;
    if (missingOptions) {
      errorDialog(
        t('Must select at least one national account processing option.'),
        t('Unable to Save Changes.'),
      );
      scrollToDisplayElementById('programs.michelin_national_account');
      return true;
    }
    return false;
  };

  const missingNationalAccountOption = (services: any): boolean => {
    const missingOptions = !services?.programs?.processes_national_accounts && (!!services?.programs?.michelin_national_account || !!services?.programs?.autointegrate);
    if (missingOptions) {
      errorDialog(
        t('Must select Processes National Account.'),
        t('Unable to Save Changes.'),
      );
      scrollToDisplayElementById('programs.processes_national_accounts');
      return true;
    }
    return false;
  };

  const missingNafaOption = (services: any): boolean => {
    const missingOptions = !services?.programs?.nafa_urban_participant && (!!services?.programs?.mounted_wheel_service || !!services?.programs?.loose_tire_pickup);
    if (missingOptions) {
      errorDialog(
        t('Must select NAFA Urban Participant.'),
        t('Unable to Save Changes.'),
      );
      scrollToDisplayElementById('programs.nafa_urban_participant');
      return true;
    }
    return false;
  };

  const missingTireWarrantyOption = (services: any): boolean => {
    // eslint-disable-next-line max-len
    const missingOption = !!services?.protections_and_warranties?.road_hazard_protection && (!services?.protections_and_warranties?.tire_warranty || services?.protections_and_warranties?.tire_warranty === 'select');
    if (missingOption) {
      errorDialog(
        t('Please select a tire warranty service option.'),
        t('Unable to Save Changes.'),
      );
      scrollToDisplayElementById('protections_and_warranties.tire_warranty');
      return true;
    }
    return false;
  };

  const noneProgramsSelectedToAdd = (programs: any): boolean => {
    if (programs && (Object.keys(programs).every((k) => !programs[k]))) return true;
    if (!programs) return true;
    return false;
  };

  const noneProgramsSelectedToRemove = (programs: any): boolean => {
    if (programs && (Object.keys(programs).every((k) => programs[k] === true))) return true;
    if (!programs) return true;
    return false;
  };

  const prevalidateServices = async (services: any, shipToNumbers: string[], operationType: string) => {
    let nafa_urban_participant: boolean | undefined;
    let processes_national_accounts: boolean | undefined;

    // Convert values according to the operation type to enable the different behaviors of check service
    switch (operationType) {
      case 'all': // undefined will be converted to false
        nafa_urban_participant = !!services?.programs?.nafa_urban_participant;
        processes_national_accounts = !!services?.programs?.processes_national_accounts;
        if (missingNationalAccountOptions(services) || missingTireWarrantyOption(services) || missingNafaOption(services) || missingNationalAccountOption(services)) return false;
        break;
      case 'add': // false will be converted to undefined
        if (noneProgramsSelectedToAdd(services?.programs) && !services?.mechanical_services && !services?.tire_services) return true;
        nafa_urban_participant = (services?.programs?.nafa_urban_participant === false) ? undefined : services?.programs?.nafa_urban_participant;
        processes_national_accounts = (services?.programs?.processes_national_accounts === false) ? undefined : services?.programs?.processes_national_accounts;
        if (missingNationalAccountOptions(services) || missingTireWarrantyOption(services)) return false;
        break;
      case 'remove': // true will be converted to undefined
        if (noneProgramsSelectedToRemove(services?.programs) && !services?.mechanical_services && !services?.tire_services) return true;
        nafa_urban_participant = (services?.programs?.nafa_urban_participant === true) ? undefined : services?.programs?.nafa_urban_participant;
        processes_national_accounts = (services?.programs?.processes_national_accounts === true) ? undefined : services?.programs?.processes_national_accounts;
        break;
      default: return false;
    }

    const finishLoading = loadingDialog(undefined, t('Validating Services designation for selected locations...'));

    // Call to endpoint which checks nafa participant & leasing management enabled locations or those available to set up nafa/leasing services
    const nafaValidations = await massValidateNafaService({
      btNumber,
      data: {
        ship_to_numbers: shipToNumbers,
        data: { services },
      },
    });
    finishLoading();

    let invalidNafaLocationsCount = 0;
    invalidNafaLocationsCount = shipToNumbers.filter((stNumber: string) => {
      if (nafa_urban_participant === undefined) return !nafaValidations.nafa_participant.includes(stNumber);
      return nafaValidations.nafa_participant.includes(stNumber);
    }).length;

    let invalidNationalAccountCount = 0;
    invalidNationalAccountCount = shipToNumbers.filter((stNumber: string) => {
      if (processes_national_accounts === undefined) return !nafaValidations.national_account.includes(stNumber);
      return nafaValidations.national_account.includes(stNumber);
    }).length;

    let mobileOnlyCount = 0;
    mobileOnlyCount = nafaValidations.mobile_only.length;

    if (invalidNafaLocationsCount === 0 && invalidNationalAccountCount === 0 && mobileOnlyCount === 0) return true;

    const msg = [];
    if (invalidNafaLocationsCount) {
      if (nafa_urban_participant === undefined) {
        msg.push(t(
          '{{count}} Locations are missing NAFA Urban Participant designation and will not be updated with the selected Urban Participant Services.',
          { count: invalidNafaLocationsCount },
        ));
      } else if (nafa_urban_participant === false) {
        msg.push(t(
          // eslint-disable-next-line max-len
          'NAFA Urban Participant is requested to be disabled for {{count}} locations that has Urban services enabled. Proceeding with the change will also disable the associated Urban services.',
          { count: invalidNafaLocationsCount },
        ));
      }
    }

    if (invalidNationalAccountCount) {
      if (processes_national_accounts === undefined) {
        msg.push(t(
          '{{count}} Locations are missing Processes National Accounts designation and those locations will not be updated with the selected national account processing options.',
          { count: invalidNationalAccountCount },
        ));
      } else if (processes_national_accounts === false) {
        msg.push(t(
          // eslint-disable-next-line max-len
          'Processes National Accounts is requested to be disabled for {{count}} locations that has national account processing options enabled. Proceeding with the change will also disable the associated those national account processing options.',
          { count: invalidNationalAccountCount },
        ));
      }
    }

    if (mobileOnlyCount) {
      msg.push(t(
        '{{count}} Locations are mobile only and those locations will not be updated with the selected in bay options.',
        { count: mobileOnlyCount },
      ));
    }
    if (msg.length > 0) {
      const res = await confirmDialog(
        msg.map((item) => <li>{item}</li>),
        t('Do you wish to continue with the updates?'),
        t('Accept'),
        t('Cancel'),
      );
      return res;
    }

    return true;
  };

  const saveServices = async (data: any, shipToNumbers: string[], type: string) => {
    const ps: any = stServices;
    if (ps?.ers_services) {
      if (ps.ers_services.towing_service_24_hrs) ps.ers_services.towing_service = true;
      if (ps.ers_services.roadside_service_24_hrs) ps.ers_services.roadside_service = true;
    }
    setSaving(true);
    const dataToSave = data;
    setStServices(dataToSave);

    if (!dataToSave.all_brands) dataToSave.all_brands = false;
    if (!dataToSave.brands) dataToSave.brands = [''];
    if (dataToSave.brands.length === 0 || dataToSave.all_brands) dataToSave.brands = [''];
    const newData = {
      data: { services: { ...dataToSave }, mode: type },
      ship_to_numbers: shipToNumbers,
    };
    await mutateLocationServices.mutateAsync({ btNumber, data: newData });

    setSelectedCount(0);
    setSavesCounter(savesCounter + 1);
    setHasSelectedServices(false);
    setStServices({ services: {} });
    if (dataGrid.current) dataGrid.current.instance.clearSelection();
    setSaving(false);
  };

  const saveHOO = async () => {
    setSaving(true);
    try {
      if (!selectedItems || selectedItems.length === 0) throw new Error('No item selected to save');

      const shipToNumbers = selectedItems.map((item) => item.ship_to.ship_to_number);
      const newData = {
        ship_to_numbers: shipToNumbers,
        data: { hours_of_operation },
      };

      await mutateLocationHOO.mutateAsync({ btNumber, data: newData });
      // if (res.error) throw (res.error.message);

      setSelectedCount(0);
      setSavesCounter(savesCounter + 1);
      setHours_of_operation({});
      stList.dataSource.reload();
      if (dataGrid.current) dataGrid.current.instance.clearSelection();
    } catch (e) {
      errorDialog(
        t('Please check your connection and try again.\nIf the issue persist, please contact support').split('\n'),
        t('Error executing Mass ST Update.'),
      );
    }
    setSaving(false);
  };

  const saveOFB = async () => {
    setSaving(true);
    try {
      if (!selectedItems || selectedItems.length === 0) throw new Error('No item selected to save');

      const values: any = {
        open_for_business: openForBusiness,
        mobile_only: mobileOnly,
        retail_service_radius: serviceRadius,
        pos_type: posType !== '' ? posType : undefined,
      };
      const items = {
        ship_to_numbers: selectedItems.map((item) => item.id),
        data: values,
      };
      const res = await mutateLocationOFB.mutateAsync({ btNumber, data: items });
      if (res.error) throw (res.error.message);

      setSelectedCount(0);
      setSavesCounter(savesCounter + 1);
      setOpenForBusiness(undefined);
      setMobileOnly(undefined);
      setServiceRadius(undefined);
      setPosType(undefined);
      if (dataGrid.current) dataGrid.current.instance.clearSelection();
    } catch (e) {
      errorDialog(
        t('Please check your connection and try again.\nIf the issue persist, please contact support').split('\n'),
        t('Error executing Mass ST Update.'),
      );
    }
    setSaving(false);
  };

  const getHOODescription = (): (string | JSX.Element)[] => {
    const hoo: HoursOfOperation = hours_of_operation;
    const enabled: (string | JSX.Element)[] = [];
    const dates = getDates(countryCode);
    const closed = <span style={{ color: '#CCC', fontStyle: 'italic' }}>{t('Closed')}</span>;
    let day: keyof HoursOfOperation;
    for (day in hoo) {
      if (!hoo || !day) continue;
      const date = dates.find((d) => d.key === day);
      if (!date) continue;
      // @ts-ignore
      const status = getTimeString(hoo[day]) || closed;
      enabled.push(
        <>
          <span style={{ width: 245, display: 'inline-block' }}>{t(date.label)}</span>
          <span style={{ width: 180, textAlign: 'center', display: 'inline-block' }}>{status}</span>
        </>,
      );
    }

    return enabled;
  };

  function getFlatObject(object: any) {
    function iter(item: any, p: any, path: any) {
      if (item && typeof item === 'object') {
        Object.keys(item).forEach((key) => {
          iter(item[key], p.concat(key), path);
        });
        return;
      }
      // eslint-disable-next-line no-param-reassign
      path[p.join('.')] = item;
    }

    const path = {};
    iter(object, [], path);
    return path;
  }

  const getServicesDescription = (): (string | JSX.Element)[] => {
    if (!stServices) return [];
    const enabled: (string | JSX.Element)[] = [];
    const flatObject = getFlatObject(stServices);

    if (selectedTab === 'services') {
      const propToReplace = new Map();
      propToReplace.set('mobile', 'Mobile');
      propToReplace.set('in_bay', 'In Bay');

      Object.entries(flatObject).forEach(([key, value]) => {
        if (key === 'protections_and_warranties.road_hazard_protection' && value) {
          enabled.push(t(get(serviceFieldLabels, key)));
        } else if (key === 'protections_and_warranties.tire_warranty' && value !== undefined) {
          const options = getOptions('short_text_road_hazard_protection_types');
          for (const i in options) {
            if (options[i].value !== value) continue;
            enabled.push(<>{options[i].label}</>);
            break;
          }
        } else if (key === 'all_brands' && value) {
          enabled.push(t(get(serviceFieldLabels, key)));
        } else if (!key.startsWith('brands') && value) {
          const type = key.split('.').filter((prop) => propToReplace.has(prop)).map((prop) => t(propToReplace.get(prop) || '')).join(' ');
          const label = key.split('.').filter((prop) => !propToReplace.has(prop)).map((prop) => prop).join('.');
          enabled.push(`${t(get(serviceFieldLabels, label))}${type ? ` ${t(type)}` : ''}`);
        }
      });
    }

    if (!stServices.all_brands && Array.isArray(stServices.brands) && stServices.brands.length > 0) {
      enabled.push(
        <>
          {t(get(serviceFieldLabels, 'brands'))}

          <br />
          <p style={{ margin: '0 0 0 30px', position: 'relative', color: '#3691ad' }}>
            {stServices.brands.join(', ')}
            .
          </p>
        </>,
      );
    }

    return enabled;
  };

  const onTabChange = async (newValue: TabName) => {
    history.push(`/${btNumber}/massSTUpdate/${newValue}`);
  };

  const onServicesChange = (newData: any) => {
    const hasSelServices = hasSelectedServicesFn(newData);
    const newServices = stServices;
    if (newData) {
      newServices.brands = newData.brands || [];
      newServices.all_brands = newData.all_brands || false;
      newServices.mechanical_services = { ...newData.mechanical_services };
      newServices.ers_services = { ...newData.ers_services };
      newServices.tire_services = { ...newData.tire_services };
      newServices.programs = { ...newData.programs };
      newServices.languages = { ...newData.languages };
      newServices.customer_convenience = { ...newData.customer_convenience };
      newServices.protections_and_warranties = { ...newData.protections_and_warranties };
      newServices.vehicle_types_serviced = { ...newData.vehicle_types_serviced };
      delete newServices.services;
      setStServices(newServices);
    }

    setHasSelectedServices(hasSelServices);
  };

  const alertNoLocationsSelected = () => {
    messageDialog(
      t('Please select at least one location to update.'),
      t('No location selected'),
      t('understood'),
    );
  };

  const alertNoHOOSelected = () => {
    messageDialog(
      t('Please change at least one day to modify the selected locations.'),
      t('No days updated'),
      t('understood'),
    );
  };

  const handleDialogs = async (type: string, saveMessage: string, selectedServicesMessage: string, boldMessage: string, nonSelectedServicesMessage: string) => {
    if (selectedCount === 0) return alertNoLocationsSelected();
    const dataToSave = getDataToSave(stServices, type);
    let shipToNumbers: any[] = [];

    try {
      if (!selectedItems || selectedItems.length === 0) throw new Error('No item selected to save');
      shipToNumbers = selectedItems.map((item) => item.ship_to.ship_to_number);

      // Validations
      if (!await prevalidateServices(dataToSave, shipToNumbers, type)) {
        setSaving(false);
        return false;
      }
    } catch (e) {
      errorDialog(
        t('Please check your connection and try again.\nIf the issue persist, please contact support').split('\n'),
        t('Error executing Mass ST Update.'),
      );
      return false;
    }

    let message: React.ReactNode[];
    const srvList = getServicesDescription();
    if (type === 'all' && srvList.length === 0) {
      message = t(nonSelectedServicesMessage, { count: selectedCount }).split('\n');
    } else {
      message = [
        ...t(selectedServicesMessage, { count: selectedCount }).split('\n'),
        <br />,
        <b>{t(boldMessage)}</b>,
        ...srvList.map((s, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={`srv-${i}`}>
            &nbsp; &#9679; &nbsp;
            {s}
          </span>
        )),
      ];
    }
    confirmDialog(
      message,
      t(saveMessage, { count: selectedCount }),
      t(saveMessage, { count: selectedCount }),
      t('Cancel'),
      () => saveServices(dataToSave, shipToNumbers, type),
    );
    return false;
  };

  const renderServicesIcons = () => {
    if (saving) {
      return (
        <Fab
          color="inherit"
          aria-label="Saving"
          style={{
            margin: '8px', position: 'fixed', zIndex: 50, right: 30, bottom: 30, height: 58, borderRadius: 29,
          }}
        >
          <Timelapse />
        </Fab>
      );
    }
    return (
      <>
        <Fab
          color={selectedCount > 0 ? 'primary' : 'inherit'}
          aria-label={selectedCount > 0 ? t('Add Selected & Remove Un-Selected Services for {{count}} location(s)',
            { count: selectedCount }) : t('Select at least one location')}
          onClick={() => handleDialogs(
            'all',
            'Update {{count}} location(s)',
            "You're about to update all services on {{count}} location(s).\nThis action can't be undone.",
            'Selected location(s) will be set to only have the following services:',
            "You're about to remove all services on {{count}} location(s).\nThis action can't be undone.",
          )}
          style={{
            margin: '8px', position: 'fixed', zIndex: 50, right: 30, bottom: 30, height: 58, borderRadius: 29,
          }}
        >
          <DoneAll />
        </Fab>
        { hasSelectedServices && (
          <>
            <Fab
              color={selectedCount > 0 && hasSelectedServices ? 'primary' : 'inherit'}
              aria-label={
                selectedCount > 0 ? t('Add selected services to {{count}} location(s)', { count: selectedCount }) : t('Select at least one location')
              }
              onClick={() => handleDialogs(
                'add',
                'Add services on {{count}} location(s)',
                "You're about to add selected services on {{count}} location(s).\nThis action can't be undone.",
                'Selected location(s) will add the following services to their current list:',
                '',
              )}
              style={{
                margin: '8px', position: 'fixed', zIndex: 50, right: 30, bottom: 100, height: 58, borderRadius: 29,
              }}
            >
              <Add />
            </Fab>
            <Fab
              color={selectedCount > 0 && hasSelectedServices ? 'primary' : 'inherit'}
              aria-label={
                selectedCount > 0 ? t('Remove selected services from {{count}} location(s)', { count: selectedCount }) : t('Select at least one location')
              }
              onClick={() => handleDialogs(
                'remove',
                'Remove services from {{count}} location(s)',
                "You're about to remove the selected services from {{count}} location(s).\nThis action can't be undone.",
                'Selected location(s) will have the following services removed from their current list:',
                '',
              )}
              style={{
                margin: '8px', position: 'fixed', zIndex: 50, right: 30, bottom: 170, height: 58, borderRadius: 29,
              }}
            >
              <Remove />
            </Fab>
          </>
        )}
      </>
    );
  };

  const renderHOOIcons = () => {
    if (saving) {
      return (
        <Fab
          color="inherit"
          aria-label="Saving"
          style={{
            margin: '8px', position: 'fixed', zIndex: 50, right: 30, bottom: 30, height: 58, borderRadius: 29,
          }}
        >
          <Timelapse />
        </Fab>
      );
    }

    return (
      <Fab
        color={selectedCount > 0 && hasHOO ? 'primary' : 'inherit'}
        aria-label={selectedCount > 0 ? t('Apply to {{count}} location(s)', { count: selectedCount }) : t('Select at least one location')}
        onClick={() => {
          if (selectedCount === 0) return alertNoLocationsSelected();
          const hooList = getHOODescription();
          if (hooList.length === 0) return alertNoHOOSelected();
          const message = [
            ...t("You're about to update the hours of operations on {{count}}.\nThis action can't be undone.", { count: selectedCount }).split('\n'),
            <br />,
            <b>{t('Selected location(s) will have the following days overriden:')}</b>,
            ...hooList.map((s, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <span key={`srv-${i}`}>
                &nbsp; &#9679; &nbsp;
                {s}
              </span>
            )),
          ];
          confirmDialog(
            message,
            t('Update {{count}} location(s)', { count: selectedCount }),
            t('Update {{count}} location(s)', { count: selectedCount }),
            t('Cancel'),
            saveHOO,
          );
          return false;
        }}
        style={{
          margin: '8px', position: 'fixed', zIndex: 50, right: 30, bottom: 30, height: 58, borderRadius: 29,
        }}
      >
        <DoneAll />
      </Fab>
    );
  };

  const renderOFBIcons = () => (
    <GlobalActions>
      <Fab
        color="inherit"
        aria-label="Saving"
        disabled={!saving}
      >
        <Timelapse />
      </Fab>
      <Fab
        color={selectedCount > 0 && locationInformationChanges ? 'primary' : 'inherit'}
        aria-label={selectedCount > 0 ? t('Apply to {{count}} location(s)', { count: selectedCount }) : t('Select at least one location')}
        onClick={() => {
          if (!locationInformationChanges) return false;
          if (selectedCount === 0) return alertNoLocationsSelected();
          const message = [
            ...t(
              "You're about to update the general information on {{count}} location(s).\nThis action can't be undone.",
              { count: selectedCount },
            ).split('\n'),
            <br />,
            <b>{t('Selected location(s) will override the following data to their current list:')}</b>,
            openForBusiness !== undefined ? (
              <span>
                &nbsp; &#9679; &nbsp;
                {t('Open for Business: {{openForBusiness}}', { openForBusiness: t(String(openForBusiness)) })}
              </span>
            ) : null,
            mobileOnly !== undefined ? (
              <span>
                &nbsp; &#9679; &nbsp;
                {t('Mobile Only: {{mobileOnly}}', { mobileOnly: t(String(mobileOnly)) })}
              </span>
            ) : null,
            serviceRadius !== undefined ? (
              <span>
                &nbsp; &#9679; &nbsp;
                {t('Service Radius: {{radius}} {{unit}}', {
                  radius: convertFromUOM(serviceRadius || 0, permissions.location?.customer_country || ''),
                  unit: t(uom),
                })}
              </span>
            ) : null,
            posType !== undefined && posType !== '' ? (
              <span>
                &nbsp; &#9679; &nbsp;
                {t('POS Integration: {{posType}}', {
                  posType,
                })}
              </span>
            ) : null,
          ];
          confirmDialog(
            message as any,
            t('Update {{count}} location(s)', { count: selectedCount }),
            t('Update {{count}} location(s)', { count: selectedCount }),
            t('Cancel'),
            saveOFB,
          );
          return false;
        }}
        disabled={saving}
      >
        <Save />
      </Fab>
    </GlobalActions>
  );

  const renderAccount = (loc: ProviderLocation): any => {
    const name = (loc.ship_to.dba_name || loc.ship_to.name || '');
    const searchTerm = dataGrid?.current?.instance.getCombinedFilter()?.filterValue.trim();

    return (
      <AccountAvatar
        avatarPosition="none"
        name={(loc.ship_to.store_number && name.indexOf(`#${loc.ship_to.store_number}`) < 0 ? `${name} #${loc.ship_to.store_number}` : name)}
        accountType="ST"
        accountDisplay="short"
        size="normal"
        useHighlight
        searchTerm={searchTerm}
        accountNumbers={
          {
            shipTo: loc.ship_to.ship_to_number,
            mdm: loc.mdm?.site_id || undefined,
          }
        }
        addressDisplay="cityState"
        address={{
          address1: undefined,
          address2: undefined,
          city: loc.city,
          state: loc.state,
          zip: loc.zip,
        }}
        terminalId=""
      />
    );
  };
  const renderMichelinIntegrations = () => (
    <Panel title={t('Michelin Integrations')}>
      <Grid container spacing={2}>
        <POSInfoIcon />
        <MustEnableField
          label={t('Update POS Integration')}
          value={posType}
          onChange={setPosType}
          defaultValue=""
          input={(
            <Select
              id="pos_type"
              data-testid="pos_type-test"
              label={t('POS Integration')}
              disabled={posType === undefined}
              value={posType}
              style={{ width: '100%' }}
              readOnly={false}
              options={getOptions('pos_type')}
              onChange={(e) => setPosType(e.target.value as string)}
            />
            )}
        />
      </Grid>
    </Panel>
  );
  return (
    <>
      <PageTitle title={t('Mass ST Update')} subtitle={subTitle} goHomeBtn />
      <Container style={{ marginBottom: 40 }}>
        <Grid container spacing={2}>
          {!tabletView && <Grid item sm={12} md={3} style={{ height: FOOTERED_CONTENT_AREA_HEIGHT }} />}
          <Grid item sm={12} md={3} style={!tabletView ? { position: 'fixed', paddingRight: 24 } : undefined}>
            <Panel>
              {useMemo(() => (
                <DataGrid
                  remoteOperations
                  scrolling={{
                    mode: 'virtual',
                    rowRenderingMode: 'virtual',
                  }}
                  key="datagrid"
                  ref={dataGrid}
                  dataSource={stList.dataSource}
                  style={{ height: FOOTERED_CONTENT_AREA_HEIGHT }}
                  onSelectionChanged={({ selectedRowKeys }) => {
                    const selectedRows = selectedRowKeys || [];
                    setSelectedItems(selectedRows || []);
                    setSelectedCount(selectedRows.length);
                  }}
                >
                  <Selection mode="multiple" showCheckBoxesMode="always" />
                  <SearchPanel visible highlightSearchText={false} />
                  <Column
                    caption={t('ST Name')}
                    cellRender={({ row }) => renderAccount(row.data)}
                    allowSearch
                    // eslint-disable-next-line max-len
                    calculateCellValue={(row: any) => `${row?.ship_to.dba_name || row?.ship_to.name} ${row?.ship_to?.ship_to_number} ${row?.mdm?.site_id} ${row?.city} ${row?.state} ${row?.zip}`.trim()}
                  />
                </DataGrid>
                // eslint-disable-next-line react-hooks/exhaustive-deps
              ), [savesCounter])}
            </Panel>
          </Grid>
          <Grid item sm={12} md={9}>
            <AppBar style={{ height: 48 }} color="primary" position="static">
              <Tabs
                value={selectedTab}
                onChange={(event, newValue: TabName) => onTabChange(newValue)}
                variant="scrollable"
                scrollButtons="on"
              >
                {permissions.allowsAction('update_open_for_business.update')
                  ? <Tab label={t('Location Information')} value="ofb" />
                  : null}
                <Tab label={t('Services')} value="services" />
                <Tab label={t('Hours of Operations')} value="hoo" />
              </Tabs>
            </AppBar>
            <TabPanel index="ofb" value={selectedTab}>
              <Panel>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Panel title={t('General Information')}>
                      <Grid container spacing={2}>
                        <MustEnableField
                          label={t('Update Open for Business')}
                          value={openForBusiness}
                          onChange={setOpenForBusiness}
                          defaultValue={false}
                          input={(
                            <Switch
                              labelPosition="left"
                              label={t('Open for Business')}
                              checked={!!openForBusiness}
                              disabled={
                                openForBusiness === undefined
                                || !permissions.allowsAction('update_open_for_business.update')
                              }
                              id="open_for_business"
                              color="primary"
                              uncheckedLabel={t('No')}
                              checkedLabel={t('Yes')}
                              onChange={() => setOpenForBusiness(!openForBusiness)}
                            />
                          )}
                        />
                        <MustEnableField
                          label={t('Update Mobile Only')}
                          value={mobileOnly}
                          onChange={setMobileOnly}
                          defaultValue={false}
                          input={(
                            <Switch
                              labelPosition="left"
                              label={t('Mobile Only')}
                              checked={!!mobileOnly}
                              id="mobile_only"
                              disabled={
                                mobileOnly === undefined || !permissions.allowsAction('update_open_for_business.update')
                              }
                              color="primary"
                              uncheckedLabel={t('No')}
                              checkedLabel={t('Yes')}
                              onChange={() => setMobileOnly(!mobileOnly)}
                            />
                          )}
                        />
                        <MustEnableField
                          label={t('Update Service Radius')}
                          value={serviceRadius}
                          onChange={setServiceRadius}
                          defaultValue=""
                          inputContainerStyle={{ paddingTop: 0 }}
                          input={(
                            <TextFieldUOM
                              id="retail_service_radius"
                              variant="standard"
                              style={{ display: 'flex', flexWrap: 'wrap' }}
                              disabled={serviceRadius === undefined}
                              uom={uom}
                              onChange={(newValue: string) => setServiceRadius(checkCRetailMaxServiceRadius(newValue))}
                              value={serviceRadius || ''}
                              label={t('Service Radius')}
                              decimals={2}
                              min={0}
                              step={1}
                            />
                          )}
                        />
                      </Grid>
                    </Panel>
                  </Grid>
                  {permissions.allowsAction('michelin_integrations.update_pos_integration')
                    && (
                    <Grid item xs={12}>
                      {renderMichelinIntegrations()}
                    </Grid>
                    )}
                </Grid>
              </Panel>
              {renderOFBIcons()}
            </TabPanel>
            <TabPanel index="services" value={selectedTab}>
              <Panel>
                <ServicesPanel
                  action="massUpdate"
                  countryCode={countryCode}
                  data={stServices}
                  onChange={onServicesChange}
                />
              </Panel>
              {renderServicesIcons()}
            </TabPanel>
            <TabPanel index="hoo" value={selectedTab}>
              <Panel>
                <HoursOfOperationEdit
                  key={`hoo${savesCounter}`}
                  holidays={countryCode}
                  hoursOfOperations={hours_of_operation}
                  onChange={(hoo) => {
                    setHours_of_operation(hoo);
                  }}
                  differentialUpdate
                />
              </Panel>
              {renderHOOIcons()}
            </TabPanel>
          </Grid>
        </Grid>
      </Container>
      <PreventTransitionPrompt when={hasSelectedServices || hasHOO} />
    </>
  );
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

function TabPanel(props: TabPanelProps): JSX.Element | null {
  if (props.index !== props.value) return null;
  return <span>{props.children}</span>;
}

export default MassSTUpdate;
